export default __webpack_public_path__ + "static/media/1449.abbe74ed.png";